<template>
  <li class="user-dropdown" ref="dropdownRef">
    <a href="#" class="dropdown-toggle" @click.prevent="toggleDropdown">
      <i class="fa-regular fa-circle-user"></i>
      <span class="username d-none d-md-inline">{{ username }}</span>
      <i class="fa fa-angle-down"></i>
    </a>
    <ul class="dropdown-menu dropdown-menu-end" v-show="dropdownOpen">
      <li>
        <a class="dropdown-item" href="#" @click.prevent="logout"><i class="fa fa-fw fa-power-off"></i> Logout</a>
      </li>
    </ul>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UserDropdown',
  data() {
    return {
      dropdownOpen: false
    }
  },
  computed: {
    ...mapGetters(['username'])
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    closeDropdown(e) {
      if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(e.target)) {
        this.dropdownOpen = false
      }
    },
    logout() {
      this.dropdownOpen = false
      this.$store.commit('logout')
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown)
  }
}
</script>

<style scoped>
.user-dropdown {
  position: relative;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  text-decoration: none;
}

.dropdown-toggle:hover,
.dropdown-toggle:focus {
  color: #fff;
  text-decoration: none;
}

.dropdown-toggle::after {
  display: none;
}

.dropdown-menu {
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1050;
  min-width: 10rem;
  background-color: var(--bs-secondary-bg);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.375rem;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.username {
  margin: 0 2px;
}
</style>




// WEBPACK FOOTER //
// src/components/UserDropdown.vue